module.exports = __webpack_public_path__ + "static/media/logo1.51edf567.webp";